import React from 'react';
import { Link } from 'react-router-dom';
import { Crown, Check, ArrowRight } from 'lucide-react';

const benefits = [
  'Seasonal tune-ups included',
  'Priority scheduling',
  '10% discount on repairs',
  'No overtime charges',
  'Extended warranty options'
];

const LoyaltySection = () => {
  return (
    <section className="py-12 lg:py-16 bg-gradient-to-br from-emerald-600 to-emerald-700 text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{backgroundImage: 'url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="0.4"%3E%3Cpath d="M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")'}}></div>
      </div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Content Side */}
          <div>
            <div className="inline-flex items-center gap-2 bg-yellow-500 text-slate-900 px-4 py-2 rounded-full text-sm font-bold mb-6">
              <Crown size={18} />
              <span>MEMBERS ONLY</span>
            </div>
            <h2 className="font-heading font-bold text-4xl md:text-5xl text-white mb-6">
              Join the ComfortLoyalty Club
            </h2>
            <p className="text-xl text-emerald-100 mb-4">
              For only <span className="font-bold text-white">$16 per month</span>
            </p>
            <p className="text-lg text-emerald-100 mb-8">
              Seasonal tune-ups, priority service & money saving benefits that will make your equipment last longer and keep you (and your home) happier.
            </p>

            {/* Benefits List */}
            <ul className="space-y-3 mb-10">
              {benefits.map((benefit, index) => (
                <li key={index} className="flex items-center gap-3">
                  <div className="w-6 h-6 bg-white/20 rounded-full flex items-center justify-center">
                    <Check size={14} className="text-white" />
                  </div>
                  <span className="text-emerald-50">{benefit}</span>
                </li>
              ))}
            </ul>

            <Link to="/comfort-loyalty" className="inline-flex items-center gap-2 bg-white text-emerald-700 font-bold py-4 px-8 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1" data-testid="join-loyalty-btn">
              Join Today <ArrowRight size={18} />
            </Link>
          </div>

          {/* Visual Side */}
          <div className="relative">
            <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-8 border border-white/20">
              <div className="text-center">
                <Crown className="w-16 h-16 text-yellow-400 mx-auto mb-4" />
                <h3 className="font-heading font-bold text-3xl text-white mb-2">ComfortLoyalty</h3>
                <p className="text-emerald-100 mb-6">Premium Membership</p>
                <div className="bg-white/10 rounded-xl p-6 mb-6">
                  <p className="text-4xl font-heading font-bold text-white">$16</p>
                  <p className="text-emerald-200">per month</p>
                </div>
                <Link to="/comfort-loyalty/sign-up" className="block w-full bg-yellow-500 text-slate-900 font-bold py-4 px-8 rounded-full hover:bg-yellow-400 transition-colors" data-testid="loyalty-signup-btn">
                  Sign Up Now
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LoyaltySection;
